/**
 * The shell both windows of Vision and values wear -- the pillar one and the value one -- and the
 * chrome of the fields inside them, so the two never drift apart again.
 *
 * Sizes taken from the design are written out where the design lands between two steps of the
 * scale; the scale itself is declared in real pixels in `app.css`.
 */
export const VISION_MODAL = {
    panelWidth: 'max-w-[820px]',
    /** The design's 48px control. */
    fieldSize: 'lg',
    fieldHeight: 'h-[48px]',
    /** The design keeps every field at 14px, which `size='lg'` alone would raise: the step named
     * `md` is the 16px one, so the 14px step has to be asked for by its own name. */
    fieldTextSize: 'sm',
    /** The lightest outline the theme carries; the library's `bordered` rests on `base-300`, a mid
     * grey that reads as a hard rule on a white panel. */
    fieldBorder: 'border-base-200',
    /** The banded header draws the panel's own full-width rule under the tab strip; the strip must
     * not draw a second one a pixel above it. */
    tabsRuleOff: 'border-b-0',
} as const;
